export const FILTER = {
  SALES_INVOICES: 'FILTER_SALES_INVOICES',
  LABELS: 'FILTER_LABELS',
  PICK_PACK: 'FILTER_PICK_PACK',
  WAREHOUSE: 'FILTER_WAREHOUSE',
  GROUPED_LIST: 'GROUPED_LIST',
  HARVEST: 'FILTER_HARVEST',
};
